var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._g(_vm._b({attrs:{"input-value":_vm.value,"hide-details":_vm.hideDetails,"label":_vm.label},on:{"change":_vm.on_change}},'v-switch',_vm.$attrs,false),_vm.unhandled_events),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }